import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

const MaintenanceRefineState = Immutable.fromJS({
    request: {
        target: null,
        mcase: null,
        card: null,
        category: null,
        showAdd: false,
        checkSet: null,
        checkItem: null,
        note: '',

        sortOrders: {
            orderby: undefined,
            code: { by: "code", asc: undefined },
            status: { by: "status", asc: undefined },
            owner: { by: "owner", asc: undefined },
            unit: { by: "unit", asc: undefined }
        },
    },

    response: {
        cases: [],
        cards: [],
        details: [],
        card: null,
    },
    options: {},
});

const maintenanceRefineReducer = handleActions({

    //Request
    ASSIGN_MODIFYING_MCASE_TARGET: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("target", payload.id);
        req = req.set("mcase", payload);
        return state.merge({
            request: req,
        })
    },

    ASSIGN_MODIFYING_MCARD_TARGET: (state, { payload }) => {
        return state.merge({
            request: state.get('request').set("card", payload),
        })
    },





    //Response
    FIND_REFINABLE_MCASES: (state, { payload }) => {
        let respObject = state.get('response');
        return state.merge({
            response: respObject.set("cases", payload.data),
        })
    },

    FIND_M_CARD: (state, { payload }) => {
        let respObject = state.get('response');
        return state.merge({
            response: respObject.set("card", payload.data),
        })
    },

    FIND_REFINABLE_M_CARDS: (state, { payload }) => {
        let respObject = state.get('response');
        return state.merge({
            response: respObject.set("cards", payload.data),
        })
    },

    FIND_REFINABLE_DETAILS: (state, { payload }) => {
        let respObject = state.get('response');
        respObject = respObject.set("details", payload.data.details);
        respObject = respObject.set("card", payload.data.card);
        return state.merge({
            response: respObject,
        })
    },


    //Simple Set Response
    ASSIGN_APPEND_SET: (state, { payload }) => {
        let resp = state.get('request');
        resp = resp.set("checkSet", payload.checkSet);
        resp = resp.set("checkItem", null);
        return state.merge({
            request: resp,
        })
    },
    ASSIGN_APPEND_ITEM: (state, { payload }) => {
        return state.merge({
            request: state.get('request').set("checkItem", payload.checkItem),
        })
    },

    ASSIGN_APPEND_NOTE: (state, { payload }) => {
        return state.merge({
            request: state.get('request').set("note", payload.note),
        })
    },
    HIDE_APPEND_DETAIL_MODAL: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("showAdd", false);
        req = req.set("checkSet", null);
        req = req.set("checkItem", null);
        return state.merge({
            request: req,
        })
    },
    SHOW_APPEND_DETAIL_MODAL: (state, { payload }) => {

        let req = state.get('request');
        req = req.set("showAdd", true);
        req = req.set("checkSet", null);
        req = req.set("checkItem", null);
        req = req.set("category", payload.category);
        return state.merge({
            request: req,
        })
    },

    SORT_REFINABLE_CARDS_BY_FIELD: (state, { payload }) => {
        state = state.updateIn(['request', 'sortOrders', payload.order.get('by'), 'asc'],
        value => value == undefined ? false : !value);
        state = state.updateIn(['response', 'cards'], () => payload.cards);
        state = state.updateIn(['request', 'sortOrders', 'orderby'], () => payload.order.get('by'));

        return state.merge();
    },


}, MaintenanceRefineState);

export default maintenanceRefineReducer;


// WEBPACK FOOTER //
// ./src/reducers/maintenanceRefineReducer.js